import actionTypes from '../constants/action-types';

const setHeight = (value) => ({
  type: actionTypes.SET_HEIGHT,
  payload: { value },
});

export default setHeight;
